<template>
    <v-card class="cart-container" style="height: 100% !important">
        <v-card-text class="pt-1 pl-0 pr-0" style="height: 100% !important">
            <template>
                <v-col cols="12" class="pt-1 pr-3">
                    <v-text-field
                        v-model="search_product"
                        label="Buscar número de orden"
                        autofocus
                        hide-details
                        prepend-inner-icon="mdi-magnify"
                        solo
                        @keydown="handleInputSearchProduct">
                    </v-text-field>
                </v-col>              

                
                
                
                <hr class="separator-line">
                
                <!--Paciente-->
                <v-row class="pl-3 pr-3">
                    <v-col cols="11" class="pb-3" v-if="customer == null">
                        <v-autocomplete                             
                            :value="customer_id"
                            :items="customers"
                            label="Paciente"
                            hide-details
                            outlined
                            :item-text="customText"
                            item-value="id"
                            clearable
                            @change="handleSelectCustomer"
                            :filter="customFilter"
                        >
                            <template v-slot:item="data">
                                <v-list-item-content>
                                    <v-list-item-title>{{ data.item.fullname }}</v-list-item-title>
                                    <v-list-item-subtitle v-if="data.item.type_document_id">
                                        {{ data.item.type_document.name }}: {{ data.item.document }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                        </v-autocomplete>
                    </v-col>

                </v-row>
                <v-row class="pl-3 pr-3" v-if="customer">
                    <v-col cols="12" class="pt-0 pb-0">
                        <v-list two-line class="pt-0 pb-0">
                            <v-list-item class="pl-1 pr-1">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <v-icon color="green" class="mr-2" size="18">
                                            fas fa-user-tag
                                        </v-icon>
                                        <span class="text-uppercase font-weight-bold cart-label-customer">{{ customer.fullname }}</span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        <span class="ml-8">{{ customer.type_document.name }}: {{ customer.document }}</span>
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle>
                                        <span class="ml-8">Fecha Nacimiento: 26/10/1992</span>
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle>
                                        <span class="ml-8">Edad: 29 Años</span>
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle>
                                        <span class="ml-8">Sexo: M</span>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn icon @click="handleClearCustomer" color="red">
                                        <v-icon>far fa-times-circle</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                        
                    </v-col>                    
                </v-row>
                <!--Fin Paciente-->
                
                <hr class="separator-line">


                <v-col cols="12" class="pt-3 pb-3">
                        <ResultsAnalysis></ResultsAnalysis>
                </v-col>

                <v-col cols="6" class="pt-3 pb-3">
                    <v-row class="pr-3">
                        <v-col cols="4" class="pt-0 pl-6">
                            <v-btn block dark color="red" height="45" @click="handleShowListRequest">
                                CANCELAR
                            </v-btn>
                        </v-col>
                        <v-col cols="8" class="pt-0 pr-6">
                            <v-btn block dark color="green" height="45" @click="handleShowPayment">
                                GRABAR {{ total | currency('S/') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>


            </template>
        </v-card-text>

        <Payment ref="payment"></Payment>

        <Prices ref="Prices"></Prices>

        <create-update ref="createUpdate"></create-update>

        <v-snackbar v-model="cant_pay" top color="error">
            {{ message_validation }}
            <v-btn dark text @click="handleCloseMessageValidation">
                Cerrar
            </v-btn>
        </v-snackbar>
    </v-card>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex'
import router from '@/router/index';
import ArrayTools from '../../helpers/ArrayTools';
import Payment from '../../components/sales/Payment';
import Prices from '../../components/sales/Prices';
import CreateUpdate from '../../components/customers/CreateUpdate';
import CreateUpdateDoctor from '../../components/doctors/CreateUpdate';
import ResultsAnalysis from '../../components/process/ResultsAnalysis'

export default {
    name: 'Patient',
    components: {
        Payment,
        Prices,
        CreateUpdate,
        ResultsAnalysis
    },
    data() {
        return {
            menuDateInvoice: false,
            cant_pay: false,
            message_validation: null,
            processing: false
        }
    },
    computed: {
        ...mapState('authentication', [
            'office_id',
        ]),
        ...mapState('customers', [
            'customers'
        ]),
        ...mapState('doctors', [
            'doctors'
        ]),
        ...mapState('companies', [
            'companies'
        ]),
        ...mapState('employees', [
            'workers'
        ]),
        ...mapState('sales', [
            'cart',
            'subtotal',
            'igv',
            'total',
            'customer',
            'customer_id',
            'doctor',            
            'doctor_id',
            'company',            
            'company_id',
            'product',
            'discount',
            'type_operation',
            'date_invoice',
            'sale_station',
            'worker',
            'worker_id',
            'rounding',
            'total_rounded',
            'total_gratuitas'
        ]),
        ...mapState('stations', [
            'selected_station'            
        ])
    },
    methods: {
        handleShowListRequest() {
            //this.router('/app/atencion/solicitud-analisis');
            this.clearData();
            router.push('/app/atencion/solicitud-analisis');
        },
        ...mapMutations('sales', [
            'set_date_invoice'
        ]),
        ...mapActions('customers', [
            'getCustomers'
        ]),
        ...mapActions('doctors', [
            'getDoctors'
        ]),
        ...mapActions('companies', [
            'getCompanies'
        ]),
        ...mapActions('employees', [
            'getWorkers'
        ]),
        ...mapActions('sales', [
            'run_set_cart',
            'replace_product_cart',
            'delete_product_cart',
            'clearAmount',
            'select_customer',
            'select_doctor',
            'select_company',
            'clearData',
            'run_set_sale',
            'setViewPrices',
            'select_product',
            'setTypeOperation',
            'setDateInvoice',
            'selectWorker',
            'storeByStation',
            'updateByStation'
        ]),
        customText(item){
            let text = item.fullname
            
            return text
        },
        customTextWorkers (item) {
            let text = item.fullname
            
            return text
        },
        handleSelectCustomer(value){
            if (value == null || value == undefined) {
                this.select_customer(null);
            } else {
                let selected_customer = ArrayTools.getElementById(this.customers, value);
                this.select_customer(selected_customer);
            }
        },
        handleSelectDoctor(value){
            if (value == null || value == undefined) {
                this.select_doctor(null);
            } else {
                let selected_doctor = ArrayTools.getElementById(this.doctors, value);
                this.select_doctor(selected_doctor);
            }
        },
        handleSelectCompany(value){
            if (value == null || value == undefined) {
                this.select_company(null);
            } else {
                let selected_company = ArrayTools.getElementById(this.companies, value);
                this.select_company(selected_company);
            }
        },
        handleSelectWorker(value){
            if (value == null || value == undefined) {
                //this.customer_id = null;
                this.selectWorker(null);
            } else {
                let selected_worker = ArrayTools.getElementById(this.workers, value);
                this.selectWorker(selected_worker);
            }
        },
        handleClearCustomer(){
            //this.customer_id = null
            this.select_customer(null);
        },
        handleClearDoctor(){
            //this.customer_id = null
            this.select_doctor(null);
        },
        handleClearCompany(){
            this.select_company(null);
        },
        handleClearWorker(){
            this.selectWorker(null);
        },
        handleDeleteItem(product){
            this.delete_product_cart(product);
        },
        handleCloseMessageValidation() {
            this.cant_pay = false;
            this.message_validation = null;
        },
        handleShowPayment(){
            if (this.customer == null) {
                this.cant_pay = true;
                this.message_validation = 'Debe seleccionar un paciente.';
            } 
            /*else if (this.doctor == null) {
                this.cant_pay = true;
                this.message_validation = 'Debe seleccionar un médico.';
            } */
            else if (this.cart.length == 0) {
                this.cant_pay = true;
                this.message_validation = 'Debe seleccionar al menos un análisis.';
            } else {
                if (this.type_operation === 'sale') {
                    this.$refs.payment.showForm('Registro de pago de venta');
                } else {
                    this.$refs.payment.showForm('Registro de pago de pedido');
                }                
            }
        },
        hanldleClickItemCart(product) {
            this.select_product(product);
            this.setViewPrices(true);
        },
        handleChangeTypeOperation (value) {
            this.setTypeOperation(value);
            this.clearData();
        },
        getAmountProductDiscount(product) {
            let amount = 0;
            let subtotal = Math.round(product.subtotal * 100) / 100;
            let discount = Math.round(product.discount_value * 100) / 100;
            amount = Math.round( (subtotal - discount) * 100) / 100;

            return amount;
        },
        handleChangeBonus (product) {
            let productItem = Object.assign({}, product);
            productItem.is_bonus = !productItem.is_bonus;
            this.replace_product_cart(productItem);
        },
        handleViewCreateCustomer () {
            this.$refs.CreateUpdate.showForm('Nuevo Paciente', 'create');
        },
        handleViewCreateDoctor () {
            this.$refs.CreateUpdateDoctor.showForm('Nuevo Médico', 'create');
        },
        handleViewCreateCompany () {
            this.$refs.CreateUpdateCompany.showForm('Nueva Empresa', 'create');
        },
        async handleSaveSale () {
            this.processing = true;
            if (this.customer == null) {
                this.cant_pay = true;
                this.message_validation = 'Debe seleccionar un cliente.';
                this.processing = false;
            } 
            else if (this.doctor == null) {
                this.cant_pay = true;
                this.message_validation = 'Debe seleccionar un Médico.';
                this.processing = false;
            }
            else if (this.company == null) {
                this.cant_pay = true;
                this.message_validation = 'Debe seleccionar una empresa';
                this.processing = false;
            }
            else if (this.cart.length == 0) {
                this.cant_pay = true;
                this.message_validation = 'Debe seleccionar al menos un producto.';
                this.processing = false;
            } else {
                let sale = this.setEntitySale();
                if (this.sale_station == null) {
                    await this.storeByStation(sale);
                } else {
                    await this.updateByStation(sale);
                }
                this.processing = false;
            }
        },
        setEntitySale () {
            let sale = {
                office_id: this.office_id,
                id: this.sale_station,
                date_invoice: this.date_invoice,
                worker_id: this.worker_id,
                customer_id: this.customer_id,
                doctor_id: this.doctor_id,
                company_id: this.company_id,
                type_operation: this.type_operation,
                products: this.cart,
                discount: this.discount,
                subtotal: this.subtotal,
                igv: this.igv,
                total: this.total,
                rounding: this.rounding,
                total_rounded: this.total_rounded,
                total_gratuitas: this.total_gratuitas,
                station_id: this.selected_station.id
            }

            return sale;
        },
        customFilter(item, queryText, itemText) {
            let textName = '';
            if (item.name) {
                textName = item.fullname.toLowerCase();             
            }
            let textDocument = '';
            if (item.document) {
                textDocument = item.document.toLowerCase();             
            }
            let searchText = queryText.toLowerCase()


            return textName.indexOf(searchText) > -1 || textDocument.indexOf(searchText) > -1
        },
    },
    created () {
        this.setTypeOperation('sale');
        if (!this.selected_station) {
            this.setDateInvoice(this.$moment().format('YYYY-MM-DD'));
        }
    },
    mounted() {
        this.getCustomers();
        this.getDoctors();
        this.getCompanies();
        let filters = {
            office_id: this.office_id
        }
        this.getWorkers(filters);
        if (!this.selected_station) {
            this.run_set_cart([]);
            this.clearData();
            this.run_set_sale(null);
        }
    }
}
</script>

<style scoped>
.label-discount{
    color: #F44336;
}

.amount-summary{
    min-height: 30px !important;
}

.list-cart-items{
    overflow-y: auto;
}

.label-amount-original {
    display: block !important;
}

.v-list-item__action-text{
    font-size: .85rem !important;
}

.label-price-discounted{
    text-decoration: line-through;
    text-decoration-color: #C62828;
}

.section-list-items-cart{
    height: 35vh;
    overflow-y: auto;
}

.cart-item-content {
    cursor: pointer;
}
</style>